module.exports = __webpack_public_path__ + "img/intro_thumb.9edcea5c.jpeg";